// src/Pages/EventMenuPage.tsx
import React from 'react';
import HeroSectionV2 from '../../../components/HeroSectionV2';
import EventMenuComponent from '../../../components/EventMenuComponent';
import Billede1 from '../../../Images/Billede1.jpg';
import AdminBackBar from "../../../components/admin/AdminBackBar";

const EventMenuPage: React.FC = () => {
    return (
        <div>
            <HeroSectionV2
                titleEn="Event Menu"
                titleDa="Event Menu"
                descriptionEn="Manage your events and zones"
                descriptionDa="Administrér events og zoner"
                imageSrc={Billede1}
            />
            <AdminBackBar
                title="Events"
                crumbs={[
                    { label: "Admin", to: "/admin" },
                    { label: "Events" } // current
                ]}
            />

            <section style={{ padding: '20px' }}>
                <EventMenuComponent />
            </section>
        </div>
    );
};

export default EventMenuPage;